import React from 'react';
import { motion } from 'framer-motion';

const Team = () => {
    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    return (
        <section id="team" className="section">
            <div className="section-header">
                <h2 className="section-title">
                    Why Choose Our <span className="highlight-yellow">Services</span>?
                </h2>
                <p className="section-subtitle">
                    All tutors hold degrees from top-tier UK universities and are passionate about helping students achieve their academic goals
                </p>
            </div>

            <div className="team-grid">
                <motion.div className="team-card" variants={cardVariants} initial="hidden" whileInView="visible" viewport={{ once: true }} whileHover={{ scale: 1.05 }}>
                    <div className="team-avatar">👨‍🔬</div>
                    <h3>Dr. James Mitchell</h3>
                    <div className="team-university">Oxford University (Physics)</div>
                    <div className="team-subjects">Physics, Mathematics, Engineering</div>
                    <div className="team-experience">8 years experience</div>
                    <p className="team-bio">PhD in Theoretical Physics from Oxford. Previously taught at Cambridge. Specializes in advanced STEM and Oxbridge preparation.</p>
                </motion.div>

                <motion.div className="team-card" variants={cardVariants} initial="hidden" whileInView="visible" viewport={{ once: true, delay: 0.2 }} whileHover={{ scale: 1.05 }}>
                    <div className="team-avatar">👩‍💼</div>
                    <h3>Sophie Chen</h3>
                    <div className="team-university">Cambridge University (Economics)</div>
                    <div className="team-subjects">Economics, Business, Mathematics</div>
                    <div className="team-experience">6 years experience</div>
                    <p className="team-bio">Economics graduate from Cambridge with expertise in IB and A-Level. Strong track record with student university placements.</p>
                </motion.div>

                <motion.div className="team-card" variants={cardVariants} initial="hidden" whileInView="visible" viewport={{ once: true, delay: 0.4 }} whileHover={{ scale: 1.05 }}>
                    <div className="team-avatar">👨‍⚖️</div>
                    <h3>Prof. Richard Hayes</h3>
                    <div className="team-university">LSE (Law)</div>
                    <div className="team-subjects">Law, English, History</div>
                    <div className="team-experience">12 years experience</div>
                    <p className="team-bio">Law professor at LSE with 12 years teaching experience. Specializes in Oxbridge law interviews and humanities subjects.</p>
                </motion.div>

                <motion.div className="team-card" variants={cardVariants} initial="hidden" whileInView="visible" viewport={{ once: true, delay: 0.6 }} whileHover={{ scale: 1.05 }}>
                    <div className="team-avatar">👩‍🔬</div>
                    <h3>Dr. Amira Patel</h3>
                    <div className="team-university">Imperial College London (Chemistry)</div>
                    <div className="team-subjects">Chemistry, Biology, Medical Sciences</div>
                    <div className="team-experience">7 years experience</div>
                    <p className="team-bio">Chemistry PhD from Imperial. Dedicated to medical school preparation and advanced sciences. Has coached 200+ students.</p>
                </motion.div>
            </div>
        </section>
    );
};

export default Team;
